<template>
  <!-- prettier-ignore -->
  <div v-if="!accepted" class="cookie-wall">
    <div class="cookie-box">
      <h2>Cookies</h2>
      <p>
        This site uses minimal cookies to improve your experience. By continuing, you
        accept the use of cookies.
      </p>

      <button class="accept-btn" @click="acceptCookies">Accept</button>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const accepted = ref(localStorage.getItem("cookiesAccepted") === "true");

const acceptCookies = () => {
  localStorage.setItem("cookiesAccepted", "true");
  accepted.value = true;
};
</script>

<style scoped>
.cookie-wall {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.cookie-box {
  background: #111;
  color: white;
  padding: 2rem;
  border-radius: 12px;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
}

.accept-btn {
  margin-top: 1rem;
  padding: 0.8rem 1.2rem;
  background: #1e88e5;
  border: none;
  border-radius: 6px;
  color: white;
  cursor: pointer;
  font-weight: 600;
}

.accept-btn:hover {
  background: #1565c0;
}
</style>
